import { create } from 'zustand';
import qs from 'qs';

const getInitialMapState = () => {
  const params = qs.parse(window.location.hash.slice(1));
  let nextState = {
    center: null,
    zoom: null,
    bearing: null,
    pitch: null,
    isUpdateByScroll: false,
    isMapUpdated: false,
  };
  if (params.origin) {
    if (params.origin.lat && params.origin.lng && params.origin.zoom) {
      nextState.center = [+params.origin?.lng, +params.origin?.lat];
      nextState.zoom = +params.origin?.zoom;
      nextState.bearing = +params.origin?.bearing;
    }
  }
  return nextState;
};

export const useMapStore = create(set => ({
  ...getInitialMapState(),
  legend: {
    scaleType: null,
    inputOutputs: null,
  },
  mapInstance: null,
  selectedGeoid: null,
  tripEndpointsData: {},
  layerShape: null,
  selectedGeoIds: null,
  mapSelectionFeatures: null,
  maxValue: null,
  minValue: null,
  filteredDashboardData: null,
  filterRange: null,
  setMinValue: minValue => set({ minValue }),
  setMaxValue: maxValue => set({ maxValue }),
  setFilteredDashboardData: filteredDashboardData =>
    set({ filteredDashboardData }),
  setFilterRange: filterRange => set({ filterRange }),
  setMapSelectionFeatures: mapSelectionFeatures =>
    set({ mapSelectionFeatures }),
  setLayerShape: layerShape => set({ layerShape }),
  setSelectedGeoIds: selectedGeoIds => set({ selectedGeoIds }),
  setLegend: ({ scaleType, inputOutputs }) =>
    set({ legend: { scaleType, inputOutputs } }),
  setMapState: ({
    center,
    zoom,
    bearing,
    pitch,
    isUpdateByScroll,
    isMapUpdated,
  }) => set({ center, zoom, bearing, pitch, isUpdateByScroll, isMapUpdated }),
  setMapInstance: map => set({ mapInstance: map }),
  setSelectedGeoid: selectedGeoid => set({ selectedGeoid }),
  setTripEndpointsData: tripEndpointsData => set({ tripEndpointsData }),
}));
